import AboutHeader from "@/components/AboutHeader";
import Image from "@/components/Image";
import LayoutFooter, { getFooterDataSource } from "@/components/LayoutFooter";
import TopicCard from "@/components/TopicCard";
import UserDescCard from "@/components/UserDescCard";
import { batchGetExplores } from "@/services";
import { cacheor } from "@/utils/server/cacheor";
import Head from "next/head";
import styles from "./index.module.less";

const replaceBr = (content) => {
  return content.split("<br/>").reduce((result, text, index) => {
    if (index !== 0) {
      result.push(<br key={`br${index}`} />);
    }
    if (text) {
      result.push(<span key={`text${index}`}>{text}</span>);
    }
    return result;
  }, []);
};

export async function getServerSideProps({ req, query }) {
  const data = await cacheor.getGrocery({
    path: "about-page",
    disableCache: query?._cache,
  });

  let topics = [];

  if (data.topics) {
    const result = await batchGetExplores({
      urlnames: data.topics.map((topic) => topic.topicId),
    });
    if (!result.err) {
      topics = result.explores.filter((i) => i);
    }
  }

  const dataSource = await getFooterDataSource({
    query,
    seoLinkInfo: {
      currentUrl: req.url,
    },
  });

  return {
    props: {
      data,
      topics,
      footerDataSource: dataSource,
    },
  };
}

export default function About({ data, topics, footerDataSource }) {
  return (
    <div className={styles.about}>
      <Head>
        <title>关于花瓣-花瓣</title>
        <meta
          name="description"
          content="用花瓣网收集和分享你喜欢的一切。使用花瓣网采集工具，你可以方便保存任意网页上的图片、视频或视频和截图。"
        ></meta>
        <meta name="keywords" content="关于花瓣"></meta>
      </Head>
      <AboutHeader />
      <div className={styles.banner}>
        <h1 style={{ display: "none" }}>关于花瓣</h1>
        <div className={styles.logo}>
          <Image
            alt="花瓣网"
            src="https://cdn.dancf.com/fe-assets/20240826/2898cb69f57ad2e706a0fb621bb86be3.png"
            width={218}
            height={50}
          />
        </div>
        <div className={styles.title}>陪你做生活的设计师</div>
      </div>
      <div className={styles.seation}>
        <div className={styles.title}>{replaceBr(data?.userTitle || "")}</div>
        <div className={styles.container}>
          {data?.users?.map((record) => (
            <UserDescCard
              className={styles.col2}
              key={record.name}
              record={record}
            />
          ))}
        </div>
      </div>
      <div className={styles.seation}>
        <div className={styles.title}>{replaceBr(data?.topicTitle || "")}</div>
        <div className={styles.container}>
          {topics.map((topic) => (
            <TopicCard
              className={styles.col4}
              key={topic.urlname}
              height={144}
              topic={topic}
            />
          ))}
        </div>
      </div>
      <LayoutFooter dataSource={footerDataSource} />
    </div>
  );
}
